import { useEffect } from 'react';
import { locatorServiceAPI } from 'shared/services';
import useOnLogout from 'common/hooks/useOnLogout';

import {
  AUTH_URL_PATH,
  AUTH_BY_IDENTITY_TOKEN_URL_PATH
} from 'entities/user';
import { USER_RESPONSE_ERRORS } from 'entities/user';

const useCheckResponseCodeFromAPI = () => {
  const onLogout = useOnLogout();

  useEffect(() => {
    locatorServiceAPI.interceptors.response.use(function onFulfilled(response) {
      return response;
    }, function onRejected(error) {
      if (error.response && error.response.status === 403 && error.response.data?.code === USER_RESPONSE_ERRORS.blockedUser && !(error.request.requestMethod === "POST" && (error.config.url === `${AUTH_URL_PATH}` || error.config.url === `${AUTH_BY_IDENTITY_TOKEN_URL_PATH}`))) {
        onLogout();
      }
      return Promise.reject(error);
    });
  }, [onLogout]);
};

export default useCheckResponseCodeFromAPI;
